import { createSelector } from 'reselect';
import { getUserItemsById, getItemsFactory } from 'state/items/selectors';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { transformItemDtosToProductItems } from 'data/transformers/product-item';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getPushUpCheckout = state => localState(state).pushUpCheckout;
export const getPushUpOptions = state => localState(state).pushUpOptions;
export const getPushUpMinimumPrice = state => localState(state).pushUpMinimumPrice;
export const getSelectedIds = state => localState(state).selectedIds;
export const getCurrentPushUpOrder = state => localState(state).pushUpOrder;
export const getPrepareUiState = state => getCurrentPushUpOrder(state).prepareUiState;
export const getActiveCheckoutModal = state => getPushUpCheckout(state).activeModal;
export const getOptions = createSelector(getPushUpOptions, pushUpOptions => pushUpOptions.options);
export const getSelectedItems = getItemsFactory(getSelectedIds, getUserItemsById);
export const getNotOptimizedSelectedItems = createSelector(getSelectedItems, items => transformItemDtosToProductItems(items.filter(item => !('international_shipping_price' in item))));
export const getCheapestPushUpOption = createSelector(getPushUpMinimumPrice, minimumPrice => minimumPrice);
export const getDefaultSelectedOption = createSelector(getPushUpOptions, _ref => {
  let {
    options
  } = _ref;
  if (!options.length) return null;
  const defaultOption = options.find(option => option.isDefault);
  return defaultOption || options[0];
});
export const getSelectedPushUpOption = state => localState(state).selectedPushUpOption || getDefaultSelectedOption(state);
export const getIsOrderFree = createSelector(getCurrentPushUpOrder, _ref2 => {
  let {
    order
  } = _ref2;
  return order && parseFloat(order.payable.amount) <= 0;
});
export const isOrderConfirmationDisabled = createSelector(getCurrentPushUpOrder, _ref3 => {
  let {
    order
  } = _ref3;
  if (!order) return true;
  return order.isTaxCoverageAvailable === false;
});
export const getHasFreePushUpAvailable = createSelector(getPushUpMinimumPrice, _ref4 => {
  let {
    hasFreeBump
  } = _ref4;
  return hasFreeBump;
});
export const getHasDiscountedPushUpAvailable = createSelector(getPushUpOptions, _ref5 => {
  let {
    options
  } = _ref5;
  return options.some(_ref6 => {
    let {
      discountedPrice
    } = _ref6;
    return discountedPrice;
  });
});
export const getInternationalPushUpsTestVariant = createSelector(getHasFreePushUpAvailable, getHasDiscountedPushUpAvailable, getAbTestByName('international_national_bump'), (hasFreePushUps, hasDiscountedPushUps, abTest) => !abTest || hasFreePushUps || hasDiscountedPushUps ? 'off' : abTest.variant);